import {useEffect, useState} from 'react';
import { jsxActions as fetchEntitiesActions } from '../../../../../actions/FetchEntities/fetchEntitiesActions.js';
import { jsxActions as qplFormActions} from '../../../../../actions/Administration/MatSettingsPage/qplFormActions.js';
import useRedux from 'infrastructure/js/hooks/useRedux';
import Overlay from 'infrastructure/js/components/Overlay/overlay';
import QplForm from './qplForm';

const getState = (state) => {
  return {
    formData: state.administration.getIn(['matSettingsPage', 'qplForm']),
    sLoggedInUser : state.login.get('loggedInUser'),
  }
}

const allActions = {
  actions: qplFormActions,
  fetchEntitiesActions: fetchEntitiesActions,
};


function QplFormWrapper (props) {
  const { state, actions } = useRedux(allActions, getState);
  const { formData, loading } = state;

  const [initialized, setInitialized] = useState(false);
  const [item, setItem] = useState(null);

  useEffect(() => {
    let qplId = props.match.params.qplId;
    if (qplId) {
      actions.actions.setQplId(+qplId);
      actions.actions.fetchFormItem(+qplId).then(data => {
        if (data) {
          setItem(data);
        }
        setInitialized(true);
      })
    }
    else {
      actions.actions.setQplId(null);
      setInitialized(true);
    }

    return () => {
      actions.actions.clearFormData();
    }
  }, [props.match.params.qplId]);


  return  initialized && !loading  ?

    <QplForm initialData={item}
             formData={formData}
             actions={{...actions.actions, ...actions.fetchEntitiesActions}}
             {...props } /> :
    <Overlay.Loading />
}

export default QplFormWrapper;
